var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 6.66383C3.19667 6.6603 3.09742 6.65239 3.00819 6.63464C2.34704 6.50313 1.83021 5.9863 1.6987 5.32515C1.66667 5.16415 1.66667 4.97055 1.66667 4.58333C1.66667 4.19612 1.66667 4.00251 1.6987 3.84152C1.83021 3.18037 2.34704 2.66354 3.00819 2.53202C3.16919 2.5 3.36279 2.5 3.75001 2.5H16.25C16.6372 2.5 16.8308 2.5 16.9918 2.53202C17.653 2.66354 18.1698 3.18037 18.3013 3.84152C18.3333 4.00251 18.3333 4.19612 18.3333 4.58333C18.3333 4.97055 18.3333 5.16415 18.3013 5.32515C18.1698 5.9863 17.653 6.50313 16.9918 6.63464C16.9026 6.65239 16.8033 6.6603 16.6667 6.66383M8.33334 10.8333H11.6667M3.33334 6.66667H16.6667V13.5C16.6667 14.9001 16.6667 15.6002 16.3942 16.135C16.1545 16.6054 15.7721 16.9878 15.3016 17.2275C14.7669 17.5 14.0668 17.5 12.6667 17.5H7.33334C5.93321 17.5 5.23314 17.5 4.69836 17.2275C4.22796 16.9878 3.84551 16.6054 3.60582 16.135C3.33334 15.6002 3.33334 14.9001 3.33334 13.5V6.66667Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.a78fc454109b989173719c6e9239351f.svg";
export { ForwardRef as ReactComponent };